<template>
  <div class="studyRecord">
    <div class="template" v-for="time in datas.times" :key="time.time">
      <div class="title" v-text="time.time"></div>
      <div class="msgTem-box">
          <!-- 这里报错是因为v-if与v-for 同行 会冲突, 因为布局不太好.但是因为不影响,就暂时不改了 -->
        <div class="msgTemplate" v-for="msg in datas.msgs" :key="msg.title" v-if="time.time==msg.time?true:false" @click="goDetail"> 
          <div class="v-msg" >
            <img :src="msg.imgUrl" />
            <p v-text="msg.title"></p>
            <p v-text="msg.uptime"></p>
            <p v-text="'已学习时长：'+msg.allTime"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      datas: {
        times: [{ time: "2019.08.20" }, { time: "2019.08.15" }],
        msgs: [
          {
            time: "2019.08.20",
            imgUrl: require("@/assets/boutique/dp-jy-qt2.png"),
            title: "农田餐桌—藕香满塘 富甲一方",
            uptime: "2019.08.11",
            allTime: "00:52:15"
          },
          {
            time: "2019.08.15",
            imgUrl: require("@/assets/boutique/dp-jy-qt3.png"),
            title: "党建新风 2019年4月27日",
            uptime: "2019.08.11",
            allTime: "00:52:15"
          },
          {
            time: "2019.08.20",
            imgUrl: require("@/assets/boutique/dp-jy-qt4.png"),
            title: "砥砺奋进再创辉煌—山东省自然资源",
            uptime: "2019.08.11",
            allTime: "00:52:15"
          },
          {
            time: "2019.08.20",
            imgUrl: require("@/assets/boutique/dp-jy-qt5.png"),
            title: "林业生态建设 第十三集：生态篇 系列之",
            uptime: "2019.08.11",
            allTime: "00:50:15"
          }
        ]
      }
    };
  },
  methods:{
      goDetail(){
          this.$router.push({path:'/boutique/videoPlayer',query:{title:'视频播放'}})
      }
  }
};
</script>

<style lang="scss" scoped>
.studyRecord {
  .template {
    .msgTem-box {
      .msgTemplate {
        p {
          &:nth-child(2) {
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            display: -webkit-box;
            // height: .8rem;
          }
          &:nth-child(3) {
            color: #999999;
            font-size: 0.26rem;
            line-height: 2;
          }
          &:nth-child(4){
              color: #ffa000;
              font-size: .26rem;
              font-weight: bold;
              line-height: 2;
          }
          padding: 0 .2rem;
        }
        &:nth-child(odd) {
          margin-right: 2%;
        }
        img {
          width: 100%;
          height: 2.5rem;
        }
        width: 49%;
        margin-top: 0.2rem;
        background: #fff;
        padding-bottom: .2rem;

      }
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding: 0 0.2rem;
    }

    .title {
      padding: 0 0.2rem;
      line-height: 2;
      background: #fff;
      margin-top: 0.2rem;
    }
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>